import { render, staticRenderFns } from "./optional-question.vue?vue&type=template&id=7ad48823"
import script from "./optional-question.vue?vue&type=script&lang=js"
export * from "./optional-question.vue?vue&type=script&lang=js"
import style0 from "./optional-question.vue?vue&type=style&index=0&id=7ad48823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports